import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  accessToken: localStorage.getItem('access_token') || '',
  tokenType: localStorage.getItem('token_type') || '',
  expiresIn: localStorage.getItem('expires_in') || 0,
  user: JSON.parse(localStorage.getItem('user')) || '',
  fromApps: JSON.parse(localStorage.getItem('from_apps')) || null,
  userSocial: {
    name:'',
    email:'',
    token:'',
    method:'',
    uid:''
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Auth/index.js